export const challenge1 = {
    name: "1º Challenge: A Escolha que transforma",
    term: "Prazo:  17/02/2022 e 21/02/2022",
    mission: [
        "Nesse primeiro challenge a sua missão é nos mostrar seu potencial para uma publi de produto. Queremos que você escolha um produto da nossa Loja e convença as suas seguidoras de como ele transformou sua vida! Nossa dica é não economizar elogios ao produtinho escolhido e usar muuuito as informações do próprio produto, como ativos, modo de uso e outros atributos. "
    ],
    missionRules: [],
    missionTip: "",
    rules: [
        "Mostrar a página do produto escolhido da Loja da Glambox ",
        "Divulgar e enaltecer o produto escolhido (escolha um que realmente mudou sua vida!). Use e abuse de elogios, mostre o antes e depois, conte todos os efeitos que ele causou em você - nada de economizar! ",
        "Mostrar o seu poder de venda e influência: convença a gente que você é uma ÓTIMA vendedora nas redes sociais! ",
        "Ter no máximo 1 minuto",
        "Marcar @glamboxbrasil e usar a #Glamstar2022"
    ],
    rulesDescription: "Você é livre para criar o seu conteúdo com o roteiro e formato que você desejar: vertical ou horizontal, pensado como trends ou talks e com foco na rede social que você preferir, desde que responda a todos os objetivos. Queremos ver a sua criatividade em ação!",
    format: ["O vídeo pode ser produzido e postado no Instagram (Feed/Reels), TikTok e/ou YouTube, mas deve respeitar o tempo limite de 1 minuto. Vamos analisar a soma das métricas de todos os canais, então quanto mais melhor!"],
    submissionDeadline1: "Poste o seu vídeo nas redes sociais entre os dias 17/02/2022 e 21/02/2022, mas lembrem-se que quanto antes você postar, mais tempo terá de bombar seu número de visualizações até a data da avaliação!",
    submissionDeadline2: "Seus links e seu vídeo favorito devem ser enviados até o dia 23/02/2022.",
    avaliationCriteria: [
        "A quantidade de views somados de todas as plataformas em que você postar o vídeo",
        "A sua capacidade de cumprir de maneira clara os objetivos desse vídeo",
        "O respeito ao tempo máximo de 1 minuto"
    ],
    test: [
        {
            title: "VÍDEO TESTE 1",
            url: "	https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21741.mp4"
        },
        {
            title: "VÍDEO TESTE 2",
            url: "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21742.mp4"
        },
        {
            title: "VÍDEO TESTE 3",
            url: "	https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21743.mp4"
        }
    ],
    videoChallenge: "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21740.mp4"
}

export const challenge2 = {
    name: "2º Challenge: A união da brasilidade com a sofisticação francesa",
    term: "Prazo: 24/03/2022 e 04/04/2022",
    mission: [
        "Nesse challenge sua missão é mostrar como os produtos da linha Patauá da L’Occitane Au Brésil, que você vai receber, exaltam as características que representam nosso país. Seu desafio é mostrar o seu potencial vendedor ao divulgar os produtos e trazer no seu vídeo a essência da marca. Ah, e pode pronunciar L’Occitane Brasil!",
        "Ao criar conteúdos nos diferentes canais, Insta, Tiktok e Youtube, você tem a chance de alcançar mais pessoas e chegar ainda mais longe!",
        "No challenge A união da brasilidade com a sofisticação francesa você deve mostrar como a linha Patauá da L’Occitane Au Brésil exalta as características fortes e positivas que representam nosso país. Aqui, seu desafio é mostrar o seu potencial vendedor ao enaltecer e divulgar os produtos, além de demonstrar a sua capacidade de montar um roteiro que transpareça a essência da marca e faça sentido para o público de ambos. Ah, apesar do nome da marca ser francês, pode pronunciar L’Occitane Brasil.",
        "Ao criar conteúdos nos diferentes canais, Insta, Tiktok e Youtube, você tem a chance de alcançar mais pessoas e chegar ainda mais longe!"
    ],
    missionRules: [],
    missionTip: "",
    rules: [
        "Utilizar pelo menos 1 dos produtos da linha Patauá que você receberá em casa",
        "Comunicar a essência da marca L'Occitane Au Brésil, divulgar e enaltecer a linha Patauá",
        "Comunicar o seu poder de criar conteúdos consoantes à identidade das marcas no Insta (reels), Tiktok e/ou Youtube.",
        "Ter no máximo 1 minuto",
        "Na legenda, marcar a @loccitaneaubresil e a @glamboxbrasil e usar as hashtags #L'Occitaneaubrésil #Patauá #Glamstar2022 #IssoRepresentaoBrasil"
    ],
    rulesDescription: "Você é livre para criar o seu conteúdo com o roteiro e formato que você desejar: vertical ou horizontal, pensado como trends ou talks e com foco na rede social que você preferir, desde que responda a todos os objetivos. Queremos ver a sua criatividade em ação!",
    format: ["O vídeo pode ser produzido e postado no Instagram (Feed/Reels), TikTok e/ou YouTube, mas deve respeitar o tempo limite de 1 minuto. Vamos analisar a soma das métricas de todos os canais, então quanto mais melhor!"],
    submissionDeadline1: "Poste o seu vídeo nas redes sociais entre os dias 24/03/2022 e 04/04/2022, mas lembre-se que, quanto antes você postar, mais tempo terá de bombar seu número de visualizações até a data da avaliação! ",
    submissionDeadline2: "Seus links e seu vídeo favorito devem ser enviados até o dia 04/04/2022.",
    avaliationCriteria: [
        "A quantidade de views somados de todas as plataformas em que você postar o vídeo",
        "A sua capacidade de representar a marca L’Occitane au Brésil de maneira clara com os objetivos desse vídeo",
        "O respeito ao tempo máximo de 1 minuto"
    ],
    test: [],
    videoChallenge: "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21512.mp4"
}

export const challenge3 = {
    name: "3º Challenge: Só na Loja da Glambox tem",
    term: "Prazo: 18/04/2022 - 22/04/2022",
    mission: ["No challenge Só na Loja da Glambox tem, você deve usar toda sua criatividade e seu potencial vendedor para apresentar os inúmeros benefícios da Loja da Glambox:"],
    missionRules: ["Descontos adicionais de até 60% para assinantes em produtos de todas as marcas da nossa Loja",
        "Opção de frete grátis em todos os pedidos da Loja, escolhendo receber suas compras junto com a sua edição mensal",
        "Desconto de 50% no valor do frete em todos os pedidos da Loja",
        "Recomendação de produtos, através da nossa tecnologia Glam Match, de acordo com as suas características e preferências como seu tipo de pele, cabelo e tons de maquiagem",
        "Seleção exclusiva de produtos com as melhores marcas de beleza",
        "Acumular Glampoints ao avaliar suas compras da loja para trocar por ainda mais produtos na nossa vitrine e turbinar suas edições. Acumule pontos dando review nos produtos comprados para turbinar suas edições"
    ],
    missionTip: "Dica de ouro:  não economize ao falar e mostrar os benefícios e vantagens de comprar seus produtos queridinhos na loja da Glambox! E lembre-se, ao compartilhar seu conteúdo nos diferentes canais, Insta, Tiktok e Youtube, você tem a chance de atingir mais pessoas e chegar ainda mais longe!",
    rules: [
        "Apresentar e divulgar ao menos 3 benefícios que só a Loja da Glambox oferece",
        "Mostrar o seu poder de venda e influência: convença a gente que você é uma ÓTIMA vendedora nas redes sociais aproveite para divulgar seu cupom e oferecer ainda mais benefícios às suas seguidoras!",
        "Ter no máximo 1 minuto",
        "Na legenda, marcar a @loccitaneaubresil e a @glamboxbrasil e usar as hashtags #L'Occitaneaubrésil #Patauá #Glamstar2022 #sonalojadaglamboxtem"
    ],
    rulesDescription: "Você é livre para criar o seu conteúdo com o roteiro e formato que você desejar: vertical ou horizontal, pensado como trends ou talks e com foco na rede social que você preferir, desde que responda a todos os objetivos. Queremos ver a sua criatividade em ação!",
    format: ["O vídeo pode ser produzido e postado no Instagram (Feed/Reels), TikTok e/ou YouTube, mas deve respeitar o tempo limite de 1 minuto. Vamos analisar a soma das métricas de todos os canais, então quanto mais melhor!"],
    submissionDeadline1: "Poste o seu vídeo nas redes sociais entre os dias 18/04/2022  e 25/04/2022, mas lembrem-se que quanto antes você postar, mais tempo terá de bombar seu número de visualizações até a data da avaliação! ",
    submissionDeadline2: "Seus links e seu vídeo favorito devem ser enviados através do portal até o dia 25/04/2022.",
    avaliationCriteria: [
        "A sua capacidade de cumprir de maneira clara e criativa os objetivos desse vídeo",
        "O respeito de todas as regras do challenge ao tempo máximo de 1 minuto",
        "A quantidade de views somados de todas as plataformas em que você postar o vídeo",
        "Sua participação em todo o concurso. Quanto mais challenges mandar, maior sua relevância no concurso"
    ],
    test: [
        {
            title: "VÍDEO TESTE 1",
            url: "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21636.mp4"
        },
        {
            title: "VÍDEO TESTE 2",
            url: "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21637.mp4"
        },
        {
            title: "VÍDEO TESTE 3",
            url: "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21744.mp4"
        }
    ],
    videoChallenge: "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21635.mp4"
}

export const challenge4 = {
    name: "4º Challenge: Glam Beauty",
    term: "Prazo: 05/05/2022 - 13/05/2022",
    mission: ["No challenge Skincare descomplicado by Glam Beauty você deve mostrar como a Glam Beauty mudou sua relação com o skincare: pode ser desmistificando algum mito de beleza, tornando produtos de mais qualidade acessíveis, te ajudando a amar a sua pele, economizando tempo e dinheiro ou qualquer outra mudança. O importante é produzir um vídeo criativo falando da sua experiência com a marca e os produtos que enviamos para você."],
    missionRules: [],
    missionTip: "",
    rules: [
        "Contar como a Glam Beauty mudou sua relação com o skincare",
        "Divulgar e enaltecer pelo menos um produto que você recebeu da Glam Beauty",
        "Mostrar o seu domínio sobre o tema de skincare e beleza ",
        "Ter no máximo 1 minuto",
        "Na legenda, marcar a @loccitaneaubresil e a @glamboxbrasil e usar as hashtags #L'Occitaneaubrésil #Patauá #Glamstar2022 #sonalojadaglamboxtem"
    ],
    rulesDescription: "Você é livre para criar o seu conteúdo com o roteiro e formato que você desejar: vertical ou horizontal, pensado como trends ou talks e com foco na rede social que você preferir, desde que responda a todos os objetivos. Queremos ver a sua criatividade em ação!",
    format: ["O vídeo pode ser produzido e postado no Instagram (Feed/Reels), TikTok e/ou YouTube, mas deve respeitar o tempo limite de 1 minuto. Vamos analisar a soma das métricas de todos os canais, então quanto mais melhor!"],
    submissionDeadline1: "Poste o seu vídeo nas redes sociais entre os dias 04/05/2022 e 13/05/2022, mas lembrem-se que quanto antes você postar, mais tempo terá de bombar seu número de visualizações até a data da avaliação!",
    submissionDeadline2: "Seus links e seu vídeo favorito devem ser enviados até o dia 13/05/2022.",
    avaliationCriteria: [
        "A sua capacidade de cumprir de maneira clara e criativa os objetivos desse vídeo",
        "Sua criatividade e qualidade técnica de seu vídeo ",
        "A quantidade de views somados de todas as plataformas em que você postar o vídeo",
        "O respeito de todas as regras do challenge"
    ],
    test: [
        {
            title: "VÍDEO TESTE 1",
            url: "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21706.mp4"
        },
        {
            title: "VÍDEO TESTE 2",
            url: 'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21707.mp4',
        },
        {
            title: "VÍDEO TESTE 3",
            url: 'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21708.mp4',
        }
    ],
    videoChallenge: "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21709.mp4"
}

export const challenge5 = {
    name: "5º challenge: Feito pra mim!",
    term: "Prazo: 05/05/2022 - 13/05/2022",
    mission: [
        "No challenge Feito pra mim!, você deve preencher o seu perfil de beleza e mostrar que como é rápida e prazerosa sua escolha de produtos ativando o filtro “*Meu perfil*”, exclusivo, da Loja da Glambox. ",
        "Não esqueça de destacar todos os benefícios da Loja e mostrar como é fácil realizar uma compra quando você recebe as sugestões de produtos de acordo com o seu perfil de beleza."
    ],
    missionRules: [],
    missionTip: "",
    rules: [
        "Preencher seu perfil de beleza na Loja da Glambox, ativar o filtro Meu Perfil e mostrar como o Glam Match encontra os produtos que mais combinam com você",
        "Ter no máximo 1 minuto",
        "Na legenda, marcar a @glamboxbrasil, além de usar as hashtags #Glamstar2022 #glamstarfeitopramim"
    ],
    rulesDescription: "Você é livre para criar o seu conteúdo com o roteiro e formato que você desejar: vertical ou horizontal, pensado como trends ou talks e com foco na rede social que você preferir, desde que responda a todos os objetivos. Queremos ver a sua criatividade em ação! ",
    format: ["Você pode subir o vídeo do challenge em qualquer canal entre Tiktok, Instagram e Youtube! Mas olha só: o vídeo só pode ter até um minuto! "],
    submissionDeadline1: "Poste o seu vídeo nas redes sociais entre os dias 18/05/2022 e 24/05/2022, mas lembrem-se que quanto antes você postar, mais tempo terá de bombar seu número de visualizações até a data da avaliação!",
    submissionDeadline2: "Seus links e seu vídeo favorito devem ser enviados até o dia 24/05/2022.",
    avaliationCriteria: [
        "A sua capacidade de cumprir de maneira clara os objetivos desse vídeo",
        "Sua criatividade e qualidade técnica de seu vídeo",
        "A quantidade de views somados de todas as plataformas em que você postar o vídeo",
        "O respeito de todas as regras do challenge"
    ],
    test: [
        {
            title: "VÍDEO TESTE 1",
            url: "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21766.mp4"
        },
        {
            title: "VÍDEO TESTE 2",
            url: 'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21767.mp4',
        }
    ],
    videoChallenge: "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21761.mp4"
}

export const challenge6 = {
    name: "6º challenge",
    term: "Prazo: 01/06/2022 - 30/06/2022",
    mission: [
        "No challenge Get Ready With Isdin a missão é inserir o Ureadin 10 Loção Hidratação Intensa nas atividades do seu dia a dia, e mostrar como esse produto faz parte da sua rotina: seja ao acordar, após o banho, entre a academia e o trabalho, reaplicando ao longo do dia…  E não se esqueça, apresente os benefícios do produto no seu challenge: "
    ],
    missionRules: ["hidratação intensa", "aplicação fácil", "sensação confortável sem deixar a pele pegajosa", "ureia ISDIN a 10%"],
    missionTip: "",
    rules: [
        "Seu vídeo precisa mostrar o produto Ureadin 10 Loção Hidratação Intensa que você recebeu e, como ele se encaixa perfeitamente em sua rotina",
        "Ter no máximo 1 minuto",
        "Na legenda marcar a @isdin.brasil e a @glamboxbrasil, além de usar as hashtags #Glamstar2022 #getreadywithisdin"
    ],
    rulesDescription: "Você é livre para criar o seu conteúdo com o roteiro e formato que você desejar: vertical ou horizontal, pensado como trends ou talks e com foco na rede social que você preferir, desde que responda a todos os objetivos. Queremos ver a sua criatividade em ação! ",
    format: ["Poste em todas as suas redes sociais: YouTube, Instagram e TikTok. Assim, você garante mais visualizações e engajamento para o seu challenge e isso será levado em consideração na avaliação!", "Use e abuse de sua criatividade, aproveite as trends do momento, capriche na edição, esperamos uma alta qualidade de uma Glampartner como você.", "Lembre-se de:"],
    formatList: ["pensar no roteiro do seu challenge", "arrumar um bom cenário, com luz e enquadramentos bons", "caprichar na edição e garantir um bom áudio", "MUITA CRIATIVIDADE!"],
    submissionDeadline1: "Fique atenta! Poste o seu vídeo nas redes sociais entre os dias 15/06/2022 e 20/06/2022, mas lembre-se que quanto antes você publicar, mais tempo terá de bombar seu número de visualizações até a data da avaliação!",
    submissionDeadline2: "Seus links e arquivo do vídeo devem ser enviados aqui pelo portal até o dia 20/06/2022.",
    avaliationCriteria: [
        "Sua capacidade de cumprir de maneira clara e criativa os objetivos desse vídeo",
        "A qualidade técnica de seu vídeo. Esteja atenta a iluminação, áudio e edição",
        "O respeito de todas as regras do challenge",
        "A quantidade de views somados de todas as plataformas em que você postar o vídeo",
        "Sua participação em todo o concurso. Quanto mais challenges participar, maior sua relevância no Glamstar",
        "Quem escolhe uma maneira de ganhar Glampoints que poucas outras escolheram terá uma vantagem!"
    ],
    test: [
        {
            title: "VÍDEO TESTE 1",
            url: "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_22048.mp4"
        },
        {
            title: "VÍDEO TESTE 2",
            url: 'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_22049.mov',
        }
    ],
    videoChallenge: "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_22047.mp4"
}

export const challenge7 = {
    name: "7º challenge",
    term: "",
    mission: [
       `No challenge "Rica de Glampoints", você deve escolher UMA forma de ganhar Glampoints (as moedas de troca do Universo Glam) e explicar muito bem para suas seguidoras. Você pode listar outras formas de ganhar pontos na parte inicial do seu vídeo, igual nós fizemos nos exemplos, mas não se esqueça que deve explicar muito bem apenas UM jeito!`
    ],
    missionRulesTitle: ["Veja todas as formas de ganhar Glampoints que nós temos hoje disponíveis:"],
    missionRules: [
        "Comprando na Loja da Glambox: a cada produto que você compra, você ganha automaticamente 1 Glampoint.", 
        "Campanhas de Hashtag: você pode participar de campanhas das nossas marcas parceiras utilizando o produto recebido e a hashtag do mês no feed do seu Instagram. Lembre-se, para ganhar os Glampoints você precisa linkar o instagram com a Glambox na área de assinante e deixar o seu perfil aberto ;). Quanto mais campanhas você participar, mais você ganha!", 
        "Feedback de produto: É só acessar sua área de assinante e responder uma pesquisa rápida de cada produto recebido na sua edição ou comprado na loja. A cada feedback, você ganha 5 Glampoints!",
        "Assinando uma de nossas assinaturas: para começar a ganhar Glampoints, basta escolher uma assinatura: box, bag ou pass, e o seu plano: anual, semestral ou mensal. Você pode ganhar até 200 pontos.",
        "Renovando a assinatura: ao renovar o seu plano, você também ganha Glampoints que variam com o seu plano e assinatura renovado.",
        "Chama as Amigas: a cada amiga que assina a Glambox usando o seu cupom de desconto, você ganha até 150 Glampoints por assinatura! Basta compartilhar seu link e cupom para ela assinar! Ah, ela também ganha pontos e brindes com o seu cupom. ;)",
    ],
    missionTip: "Dica da Glam: mostre que você é uma expert no Universo Glam e que sabe no detalhe todas as formas de ganhar Glampoints, inclusive aquelas que ninguém conhece ainda e são uma novidade. Quem escolher explicar formas que ainda são pouco conhecidas, terá uma vantagem na avaliação final!",
    missionFooter: [
        "Lembre-se: Sua joia é um multiplicador de Glampoints, ou seja, dependendo da sua joia, você multiplica os Glampoints recebidos em cada ação executada.",
        "Todas elas você encontra em: "
    ],
    missionFooterLinks: "https://glambox.com.br/clube/glampoints",
    benefitsTitle: "Benefícios para se tornar uma influencer de sucesso",
    benefitsList: [
        "Os 10 melhores vídeos serão divulgados nas redes sociais (TikTok, Instagram e/ou  YouTube) da Glambox! Mais de um milhão de seguidores verão seu vídeo! Capriche na produção!",
        "Os 5 melhores vídeos serão impulsionados com mídia no nosso Instagram para que você tenha ainda mais audiência no seu perfil!",
        "O melhor vídeo para cada maneira de ganhar Glampoints vai aparecer no site da Glambox no link: https://glambox.com.br/clube/glampoints"
    ],
    benefitsLink: "https://glambox.com.br/clube/glampoints",
    rules: [
        "Realizar seu vídeo seguindo a missão proposta (confira no primeiro tópico).",
        "Ter no máximo 1 minuto",
        "Marcar a @glamboxbrasil, além de usar as hashtags #Glamstar2022 #ricadeglampoints na legenda."
    ],
    format: [
        "Poste em todas as suas redes sociais: YouTube, Instagram e TikTok. Assim, você garante mais visualizações e engajamento para o seu challenge e isso será levado em consideração na avaliação!",
        "Use e abuse de sua criatividade, aproveite as trends do momento, capriche na edição, esperamos uma alta qualidade de uma Glampartner como você.",
        "Lembre-se de:" 
    ],
    formatList: [
        "Pensar no roteiro do seu challenge;", 
        "Arrumar um bom cenário, com luz e enquadramentos bons;", 
        "Caprichar na edição e garantir um bom áudio; ", 
        "MUITA CRIATIVIDADE!"
    ],
    submissionDeadline1: "Fique atenta! Poste o seu vídeo nas redes sociais e o envie aqui no portal até o dia 12/07/2022. Quanto antes você publicar, mais tempo terá de bombar seu número de visualizações até a data da avaliação!",
    avaliationCriteria: [
        "Sua capacidade de cumprir de maneira clara e criativa os objetivos desse vídeo.",
        "A qualidade técnica de seu vídeo. Esteja atenta a iluminação, áudio e edição.",
        "O respeito de todas as regras do challenge.",
        "A quantidade de views somados de todas as plataformas em que você postar o vídeo.",
        "Sua participação em todo o concurso. Quanto mais challenges participar, maior sua relevância no Glamstar."
    ],
    test: [
        {
            title: "VÍDEO TESTE 1",
            url: "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_22048.mp4"
        },
        {
            title: "VÍDEO TESTE 2",
            url: 'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_22049.mp4',
        },
        {
            title: "VÍDEO TESTE 3",
            url: 'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_22050.mp4',
        }
    ],
    videoChallenge: "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_22047.mp4"
}

export const challenge8 = {
    name: "8º challenge",
    term: "",
    mission: [
       `No challenge ”Seu Brilho é Único”,  com Eudora, a sua missão é criar uma make completa e criativa, que contenha obrigatoriamente boca e olhos feitos, utilizando a Palette Crystal Niina Secrets e o Batom Eudora Glam Duo Clinical Micropigmentação`
    ],
    missionRulesTitle: [],
    missionRules: [],
    missionTip: "",
    missionFooter: [
        "Lembre-se: Sua joia é um multiplicador de Glampoints, ou seja, dependendo da sua joia, você multiplica os Glampoints recebidos em cada ação executada.",
        "Todas elas você encontra em: "
    ],
    missionFooterLinks: "",
    benefitsTitle: "Benefícios para se tornar uma influencer de sucesso",
    benefitsList: [
        "Os 5 melhores vídeos serão divulgados nas redes sociais (TikTok, Instagram e/ou  YouTube) da Glambox! Mais de um milhão de seguidores verão seu vídeo! Capriche na produção!",
        "Os 2 melhores vídeos serão impulsionados com mídia no nosso Instagram para que você tenha ainda mais audiência no seu perfil!",
        "Marcar @eudora e  @glamboxbrasil, além de usar as hashtags #Glamstar2022 #EudoranoGlamstar e #SeuBrilhoeUnico na legenda."
    ],
    benefitsLink: "",
    rules: [
        "Realizar o vídeo seguindo a missão proposta.",
        "Mostrar e falar o nome dos dois produtos que recebeu (Palette Crystal Niina Secrets e Batom Eudora Glam Duo Clinical Micropigmentação).",
        "Marcar @eudora e  @glamboxbrasil, além de usar as hashtags #Glamstar2022 #EudoranoGlamstar e #SeuBrilhoeUnico na legenda."
    ],
    format: [
        "Publique seu vídeo em todas as suas redes sociais: YouTube, Instagram e TikTok, garantindo mais visualizações e engajamento para o seu challenge. Levaremos isso em consideração em sua avaliação!",
        "Seja criativa, use e abuse das cores dos produtos Eudora, aproveite as trends do momento e explore cortes e transições que estão bombando nas redes sociais! Isso vai ajudar você a se destacar na competição e garantir a sua vaga na etapa eliminatória.",
        "Dedique-se na edição, esperamos uma alta qualidade de uma Glampartner como você!",
        "Lembre-se de:",
    ],
    formatList: [
        "Prepare um roteiro para seu challenge;", 
        "Arrume um bom cenário com luz e enquadramentos bons;", 
        "Capriche na edição e garanta bom áudio;", 
        "USE TODA SUA CRIATIVIDADE!"
    ],
    submissionDeadline1: "Publique o seu vídeo em suas redes sociais e não se esqueça de enviá-lo pelo portal até o dia 25/07/2022. Mas lembre-se que quanto antes você publicar, mais tempo terá de bombar seu número de visualizações até a data da avaliação! ",
    avaliationCriteria: [
        "Sua capacidade de cumprir de maneira clara e criativa os objetivos desse vídeo.",
        "A qualidade técnica de seu vídeo. Esteja atenta a iluminação, áudio e edição.",
        "O respeito de todas as regras do challenge.",
        "A quantidade de views somados de todas as plataformas em que você postar o vídeo.",
        "Sua participação em todo o concurso. Quanto mais challenges participar, maior sua relevância no Glamstar."
    ],
    test: [
        {
            title: "VÍDEO TESTE 1",
            url: "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_22069.mp4"
        },
        {
            title: "VÍDEO TESTE 2",
            url: 'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_22070.mp4',
        },
        {
            title: "VÍDEO TESTE 3",
            url: 'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_22071.mp4',
        }
    ],
    videoChallenge: "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_22072.mp4"
}

export const challenge9 = {
    name: "9º challenge",
    term: "",
    mission: [
        `No challenge <b>“Wishlist de Beleza”</b>, <b>a sua missão é mostrar a variedade de produtos da Loja da Glambox.</b> Para isso, você deve montar a sua lista de compras dos sonhos com pelo menos 5 produtos diferentes, combinando marcas e categorias. Pode incluir compras para você, familiares e amigos.`
        , `São mais de 5.000 produtos das melhores marcas de beleza, desde os melhores perfumes de marcas internacionais para ocasiões especiais, aos favoritos que te acompanham no dia a dia (e inclusive milhares de produtos para eles).`
    ],
    missionRulesTitle: [],
    missionRules: [],
    missionTip: "",
    missionFooter: [
        "Lembre-se: Sua joia é um multiplicador de Glampoints, ou seja, dependendo da sua joia, você multiplica os Glampoints recebidos em cada ação executada.",
        "Todas elas você encontra em: "
    ],
    missionFooterLinks: "",
    benefitsTitle: "Benefícios para se tornar uma influencer de sucesso",
    benefitsList: [
        "Os 5 melhores vídeos serão divulgados nas redes sociais (TikTok, Instagram e/ou  YouTube) da Glambox! Mais de um milhão de seguidores verão seu vídeo! Capriche na produção!",
        "Os 2 melhores vídeos serão impulsionados com mídia no nosso Instagram para que você tenha ainda mais audiência no seu perfil!",
        "Marcar @eudora e  @glamboxbrasil, além de usar as hashtags #Glamstar2022 #EudoranoGlamstar e #SeuBrilhoeUnico na legenda."
    ],
    benefitsLink: `
        Desenhamos todas essas divulgações para te ajudar a ganhar ainda mais destaque nas suas redes sociais e ainda mais seguidoras, te ajudando a virar uma influencer de sucesso!
    `,
    rules: [
        `Realizar o vídeo seguindo a missão proposta.`,
        `Citar a Loja da Glambox e mostrar a sua lista com pelo menos 5 produtos no site da Loja da Glambox.`,
        "Ter no máximo 1 minuto.",
        "Marcar @glamboxbrasil, além de usar a hashtag #Glamstar2022 #WishlistDeBeleza"
    ],
    format: [
        "Publique seu vídeo em todas as suas redes sociais: YouTube, Instagram e TikTok, garantindo mais visualizações e engajamento para o seu challenge. Levaremos isso em consideração em sua avaliação!",
        "Seja criativa e explore transições, áudios que estão bombando e não esqueça de mostrar a tela da Loja com sua lista de compras, seja no computador ou no celular. Isso vai ajudar você a se destacar na competição e garantir a sua vaga no próximo desafio!",
        "Dedique-se na edição, esperamos uma alta qualidade de uma Glampartner como você!",
        "Lembre-se de:",
    ],
    formatList: [
        "Prepare um roteiro para seu challenge;", 
        "Arrume um bom cenário com luz e enquadramentos bons;", 
        "Capriche na edição e garanta bom áudio;", 
        "USE TODA SUA CRIATIVIDADE!"
    ],
    submissionDeadline1: "Publique o seu vídeo em suas redes sociais e não se esqueça de enviá-lo pelo portal até o dia 10/08/2022. Mas lembre-se que quanto antes você publicar, mais tempo terá de bombar seu número de visualizações até a data da avaliação!",
    avaliationCriteria: [
        "Sua capacidade de cumprir de maneira clara e criativa os objetivos desse vídeo.",
        "A qualidade técnica de seu vídeo. Esteja atenta a iluminação, áudio e edição.",
        "O respeito de todas as regras do challenge.",
        "A quantidade de views somados de todas as plataformas em que você postar o vídeo.",
        "Sua participação em todo o concurso. Quanto mais challenges participar, maior sua relevância no Glamstar.",
        "Conseguir passar a grande variedade de produtos e marcas da Loja da Glambox da maneira mais clara e criativa possível."
    ],
    test: [
        {
            title: "VÍDEO TESTE 1",
            url: "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_22152.mp4"
        },
        {
            title: "VÍDEO TESTE 2",
            url: 'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_22153.mp4',
        }
    ],
    videoChallenge: "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_22151.mp4"
}

export const challenge10 = {
    name: "10º challenge",
    term: "",
    mission: [
        `No challenge "O Guia do Protetor Solar" a sua missão é criar o SEU guia usando o protetor Fusion Water da Isdin, que você recebeu em casa. E para criar o guia do protetor solar perfeito, conte o que é essencial para você na hora de escolher um protetor e mostre para suas seguidoras os atributos que só o Fusion Water da Isdin tem: `
    ],
    missionRulesTitle: [],
    missionRules: [
        "FPS alto",
        "Textura ultraleve com absorção imediata",
        "Controle de oleosidade da pele sem deixar resíduos",
        "Com ácido hialurônico, que proporciona a hidratação da pele",
        "Pode ser aplicado em cima da make"
    ],
    missionTip: "",
    missionFooter: [],
    missionFooterLinks: "",
    benefitsTitle: "Benefícios para se tornar uma influencer de sucesso",
    benefitsList: [
        "Os 2 melhores vídeos serão publicados nas redes sociais da Glambox  (TikTok, Instagram e/ou  YouTube) e  impulsionados com mídia no nosso Instagram para que você tenha ainda mais audiência no seu perfil!",
    ],
    benefitsLink: `
        Desenhamos todas essas divulgações para te ajudar a ganhar ainda mais destaque nas suas redes sociais e ainda mais seguidoras, te ajudando a virar uma influencer de sucesso!
    `,
    rules: [
        `Realizar o vídeo seguindo a missão proposta.`,
        "Ter no máximo 1 minuto.",
        "Marcar @glamboxbrasil, além de usar a hashtag #Glamstar2022 #GuiaDoProtetorSolar #IsdinNoGlamstar"
    ],
    format: [
        "Publique seu vídeo em todas as suas redes sociais: YouTube, Instagram e TikTok, garantindo mais visualizações e engajamento para o seu challenge. Levaremos isso em consideração em sua avaliação!",
        "Seja criativa, e explore transições, áudios que estão bombando e não esqueça de mostrar a protetor solar Fusion Water da Isdin, que você recebeu em casa. Isso vai ajudar você a se destacar na competição e garantir uma das 20 vagas no próximo desafio!",
        "Dedique-se na edição, esperamos uma alta qualidade de uma Glampartner como você!",
        "Lembre-se de:",
    ],
    formatList: [
        "Prepare um roteiro para seu challenge;", 
        "Arrume um bom cenário com luz e enquadramentos bons;", 
        "Capriche na edição e garanta bom áudio;", 
        "USE TODA SUA CRIATIVIDADE!"
    ],
    submissionDeadline1: "Publique o seu vídeo em suas redes sociais e não se esqueça de enviá-lo pelo portal até o dia 29/08/2022. Mas lembre-se que quanto antes você publicar, mais tempo terá de bombar seu número de visualizações até a data da avaliação!",
    avaliationCriteria: [
        "Sua capacidade de cumprir de maneira clara e criativa os objetivos desse vídeo.",
        "A qualidade técnica de seu vídeo. Esteja atenta a iluminação, áudio e edição.",
        "O respeito de todas as regras do challenge.",
        "A quantidade de views somados de todas as plataformas em que você postar o vídeo.",
        "Sua participação em todo o concurso. Quanto mais challenges participar, maior sua relevância no Glamstar.",
        "Criar o guia do protetor solar mais completo para suas seguidoras, para que elas possam utilizar em suas rotinas de beleza."
    ],
    test: [
        {
            title: "VÍDEO TESTE 1",
            url: "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_22185.mp4"
        },
        {
            title: "VÍDEO TESTE 2",
            url: 'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_22186.mp4',
        }
    ],
    videoChallenge: "https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_22188.mp4"
}